import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {ComponentBase} from '@drl/core/component-base';
import {NbDialogRef} from '@nebular/theme';
import {AppoinmentService} from '../appoinment.service';

@Component({
  selector: 'app-dialog-update',
  templateUrl: './dialog-update.component.html',
  styleUrls: ['./dialog-update.component.scss'],
})
export class DialogUpdateComponent extends ComponentBase {
  IsEdit;
  constructor(
    public dialogRef: NbDialogRef<DialogUpdateComponent>,
    private readonly router: Router,
    public readonly patientService: AppoinmentService,
  ) {
    super();
  }
  redirectToCalender() {
    this.dialogRef.close();
    this.router.navigateByUrl('main/care-central');
  }
}
